export * from './layout';
export * from './notification';
export * from './building';
export * from './cloud';
export * from './tree';
export * from './search';

import { LayoutComponents } from './layout';
import { NotificationComponents } from './notification';
import { BuildingComponents } from './building';
import { CloudComponents } from './cloud';
import { TreeComponents } from './tree';
import { SearchComponents } from './search';



export const Components = [
    ...LayoutComponents,
    ...NotificationComponents,
    ...BuildingComponents,
    ...CloudComponents,
    ...TreeComponents,
    ...SearchComponents
];